var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcModel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1904 6.648L8.44769 4.4605C8.34806 4.40219 8.23637 4.37381 8.12494 4.37506C8.01875 4.37631 7.91281 4.40469 7.81775 4.45988L4.06044 6.64738C3.86819 6.75938 3.74994 6.96506 3.74994 7.18756V11.5626C3.74994 11.7851 3.86819 11.9908 4.06044 12.1027L7.81775 14.2902C7.91494 14.3467 8.01625 14.3751 8.12494 14.3751C8.23387 14.3751 8.35019 14.3467 8.44769 14.2896L12.1904 12.1021C12.3822 11.9901 12.5 11.7847 12.5 11.5626V7.18756C12.5 6.96537 12.3822 6.76 12.1904 6.648ZM8.13169 5.72362L10.6364 7.18756L8.13169 8.6515L5.61719 7.18756L8.13169 5.72362ZM5 8.27456L7.5 9.73025V12.6587L5 11.203V8.27456ZM8.75 12.6651V9.73787L11.25 8.27669V11.2039L8.75 12.6651Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 18.75C8.01619 18.75 7.90744 18.7216 7.81006 18.6649L0.310062 14.2899C0.118125 14.1779 0 13.9723 0 13.75V5C0 4.77769 0.118125 4.57212 0.310062 4.46012L7.81006 0.085125C7.90744 0.028375 8.01619 0 8.125 0C8.23381 0 8.34256 0.028375 8.43994 0.085125L15.3149 4.0955L14.6851 5.17519L8.125 1.3485L1.25 5.35887V13.3909L8.125 17.4013L15 13.3909V8.74987H16.25V13.7499C16.25 13.9722 16.1319 14.1777 15.9399 14.2897L8.43994 18.6647C8.34256 18.7215 8.23381 18.75 8.125 18.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcModel);
export default __webpack_public_path__ + "static/media/ic-model.d589b6dd3dde5c0cefb08e680b9aa38c.svg";
export { ForwardRef as ReactComponent };